import Loader from "../../../Loader/Loader"
import "./PaymentProcessingSection.scss"

const PaymentProcessingSection = () => {
    return (
        <>
            <Loader 
                start={true}
                msg={'Processing Payment, please do not refresh page.'}
            />
        </>
    )
}

export default PaymentProcessingSection